import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3f267d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-page" }
const _hoisted_2 = {
  key: 0,
  class: "dashboard-page__error"
}
const _hoisted_3 = { class: "dashboard-page__greeting" }
const _hoisted_4 = { class: "dashboard-page__title" }
const _hoisted_5 = { class: "dashboard-page__section dashboard-page__charts" }
const _hoisted_6 = { class: "dashboard-page__section dashboard-page__tasks" }

import { computed, reactive } from "vue";
import StatsCards from "@/widgets/dashboard/StatsCards.vue";
import DocumentsChart from "@/widgets/dashboard/DocumentsChart.vue";
import TasksBoard from "@/widgets/dashboard/TasksBoard.vue";
import NewsSection from "@/widgets/dashboard/NewsSection.vue";
import DashboardDetailsModal from "@/widgets/dashboard/DashboardDetailsModal.vue";
import {
  getGreetingByTime,
  useDashboardMain,
} from "@/composables/useDashboardMain";
import type { DashboardDetailType } from "@/types/dashboard/DashboardTypes";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  profile,
  incoming,
  outgoing,
  tasksToday,
  overdueTasks,
  tasksTodayCount,
  overdueTasksCount,
  error,
  reload,
} = useDashboardMain();

void reload();

const detailsModal = reactive<{
  show: boolean;
  title: string;
  type: DashboardDetailType;
  templateId?: string;
}>({
  show: false,
  title: "",
  type: "TOTAL",
  templateId: undefined,
});

function openDashboardDetails(
  type: DashboardDetailType,
  title: string,
  templateId?: string
) {
  detailsModal.type = type;
  detailsModal.title = title;
  detailsModal.templateId = templateId;
  detailsModal.show = true;
}

const greeting = computed(() => getGreetingByTime());

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(error))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_unref(error)) + " ", 1),
          _createElementVNode("button", {
            type: "button",
            class: "dashboard-page__retry",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(reload) && _unref(reload)(...args)))
          }, _toDisplayString(_ctx.$t("dashboard.retry")), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(greeting)) + ", " + _toDisplayString(_unref(profile)?.fullName) + "! ", 1)
      ]),
      _createVNode(_component_router_link, {
        to: { name: 'DocumentCreate' },
        class: "dashboard-page__create-btn"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("layout.createDocument")), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(StatsCards, {
      class: "dashboard-page__section",
      onOpenDetails: openDashboardDetails
    }),
    _createElementVNode("section", _hoisted_5, [
      _createVNode(DocumentsChart, {
        title: _ctx.$t('dashboard.incomingDocuments'),
        items: _unref(incoming),
        "detail-type": "INCOMING",
        onOpenDetails: openDashboardDetails
      }, null, 8, ["title", "items"]),
      _createVNode(DocumentsChart, {
        title: _ctx.$t('dashboard.outgoingDocuments'),
        items: _unref(outgoing),
        "detail-type": "OUTGOING",
        onOpenDetails: openDashboardDetails
      }, null, 8, ["title", "items"])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createVNode(TasksBoard, {
        title: _ctx.$t('dashboard.tasksToday'),
        tasks: _unref(tasksToday),
        "total-count": _unref(tasksTodayCount),
        "detail-type": "TASKS_TODAY",
        variant: "today",
        onOpenDetails: openDashboardDetails
      }, null, 8, ["title", "tasks", "total-count"]),
      _createVNode(TasksBoard, {
        title: _ctx.$t('dashboard.overdueTasks'),
        tasks: _unref(overdueTasks),
        "total-count": _unref(overdueTasksCount),
        "detail-type": "TASKS_OVERDUE",
        variant: "overdue",
        onOpenDetails: openDashboardDetails
      }, null, 8, ["title", "tasks", "total-count"])
    ]),
    _createVNode(NewsSection, { class: "dashboard-page__section" }),
    _createVNode(DashboardDetailsModal, {
      show: _unref(detailsModal).show,
      title: _unref(detailsModal).title,
      type: _unref(detailsModal).type,
      "template-id": _unref(detailsModal).templateId,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_unref(detailsModal).show = false))
    }, null, 8, ["show", "title", "type", "template-id"])
  ]))
}
}

})